"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.overlayInnerStyles = exports.getAvatarAddBtnStyles = exports.getAvatarGroupStyles = exports.getAvatarStyles = exports.avatarProfileSizes = exports.getAvatarTextBaseStyle = exports.sizesMap = void 0;
var react_1 = require("@emotion/react");
var variables_1 = require("../../../style/variables");
exports.sizesMap = {
    '3xs': { root: 12, iconFont: 8, indicator: 4, groupMargin: 2, font: 8 },
    '2xs': { root: 16, iconFont: 10, indicator: 4, groupMargin: 2, font: 10 },
    xs: { root: 24, iconFont: 16, indicator: 6, groupMargin: 4, font: 12 },
    sm: { root: 32, iconFont: 20, indicator: 8, groupMargin: 8, font: 14 },
    md: { root: 40, iconFont: 24, indicator: 10, groupMargin: 12, font: 16 },
    lg: { root: 48, iconFont: 28, indicator: 12, groupMargin: 16, font: 18 },
    xl: { root: 56, iconFont: 32, indicator: 14, groupMargin: 16, font: 20 },
    '2xl': { root: 64, iconFont: 32, indicator: 16, groupMargin: 16, font: 24 },
};
var getAvatarTextBaseStyle = function (color) { return react_1.css({
    color: "var(" + variables_1.RootColor[color].DARK_3 + ")",
    backgroundColor: "var(" + variables_1.RootColor[color].LIGHT_4 + ")",
}); };
exports.getAvatarTextBaseStyle = getAvatarTextBaseStyle;
exports.avatarProfileSizes = {
    sm: { root: 72, iconFont: 36, indicator: 12, font: 30 },
    md: { root: 96, iconFont: 48, indicator: 12, font: 36 },
    lg: { root: 160, iconFont: 80, indicator: 16, font: 60 },
};
function getAvatarStyles(wrapperSize, fontSize, indicatorSize, imageFit, type, clickable) {
    if (imageFit === void 0) { imageFit = 'cover'; }
    return {
        root: react_1.css({
            position: 'relative',
            width: wrapperSize,
            height: wrapperSize,
            borderRadius: type === 'user' ? '50%' : 4,
            cursor: clickable ? 'pointer' : undefined,
        }),
        content: react_1.css({
            backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
            display: 'flex',
            width: '100%',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            borderRadius: type === 'user' ? '50%' : 4,
            '& > img': {
                width: '100%',
                height: '100%',
                objectFit: imageFit,
                display: 'block',
            },
        }),
        text: react_1.css({
            fontWeight: 600,
            fontSize: fontSize,
            textTransform: 'uppercase',
        }),
        indicator: react_1.css({
            position: 'absolute',
            width: indicatorSize,
            height: indicatorSize,
            bottom: -2,
            right: -2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }),
    };
}
exports.getAvatarStyles = getAvatarStyles;
function getAvatarGroupStyles(size) {
    return {
        avatarGroupWrapper: {
            display: 'flex',
            alignItems: 'center',
            '&  > div:first-of-type': {
                marginLeft: 0,
                boxShadow: '0 0 0 1.5px transparent',
            },
            '& > *': {
                marginLeft: -1 * exports.sizesMap[size].groupMargin,
                boxShadow: '0 0 0 1.5px white',
            },
        },
    };
}
exports.getAvatarGroupStyles = getAvatarGroupStyles;
function getAvatarAddBtnStyles(size) {
    return {
        root: react_1.css({
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#fff',
            borderRadius: 200,
            justifyContent: 'center',
            fontSize: exports.sizesMap[size].iconFont,
            outline: 'none',
            cursor: 'pointer',
            border: "1px dashed var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
            color: "var(" + variables_1.RootColor.Gray.LIGHT_1 + ")",
            overflow: 'hidden',
            width: exports.sizesMap[size].root,
            height: exports.sizesMap[size].root,
            '&:focus': {
                boxShadow: "0px 0px 0px 4px var(" + variables_1.RootColor.Gray.LIGHT_4 + ")",
                backgroundColor: '#fff',
            },
            '&:hover': {
                backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
            },
            '&:disabled': {
                color: "var(" + variables_1.RootColor.Gray.LIGHT_3 + ")",
                backgroundColor: "var(" + variables_1.RootColor.Gray.LIGHT_5 + ")",
                borderColor: "var(" + variables_1.RootColor.Gray.LIGHT_3 + ")",
                cursor: 'not-allowed',
            },
        }),
    };
}
exports.getAvatarAddBtnStyles = getAvatarAddBtnStyles;
exports.overlayInnerStyles = {
    opacity: 1,
    padding: 0,
    overflow: 'hidden',
    borderRadius: 8,
    background: "var(" + variables_1.RootColor.White + ")",
    border: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_4 + ")",
    boxShadow: "var(" + variables_1.Shadow.lg + ")",
};
